module.exports = __webpack_public_path__ + "media/src/img/nd_qr_sber-0bf101d776200c19460886994c3b7786.png";